import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import fondo from './fondo.jpg';

export const CredencialCard = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	background-color: rgba(255, 255, 255, 0.9);
	border: 2px solid black;
	border-radius: 8px;
	margin: 10px;
	padding: 10px;
`;
export const CredentialsContainer = styled.div`
	width: 90%;
	margin: 20px auto;
	border: 2px solid black;
	border-radius: 8px;
	background-image: url(${fondo});
	background-size: cover;
`;
export const Button = styled.button`
	padding: 3px 5px;
	margin-left: 15px;
`;
export const AlumnoData = styled.p`
	text-align: center;
	font-weight: 700;
	color: ${({ color }) => (color ? color : '#ffffff')};
`;
export const Img = styled.img`
	width: ${({ width }) => (width ? width : '')};
	height: ${({ height }) => (height ? height : '')};
`;
export const Text = styled.p`
	margin: 0px;
	font-size: ${({ size }) => (size ? size : '14px')};
	text-align: center;
	color: #ffffff;
`;

export const MainLogoContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const HomeContainer = styled.div`
	width: 100%;
	min-height: 900px;
	background-image: url(${fondo});
	background-size: cover;
	background-position: center;
`;

export const Nav = styled.nav`
	height: 40px;
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	background-color: #000000;
`;
export const NavLink = styled(Link)`
	color: #ffffff;
	text-decoration: none;
	&:hover {
		color: green;
	}
`;
export const CalendarContainer = styled.div`
	text-align: center;
	width: 400px;
`;
export const CalendarList = styled.ol`
	list-style: none;
	border: 1px solid black;
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	padding: 10px;
`;
export const CalendarHeader = styled.li`
	background-color: #eee;
	font-weight: bold;
`;
export const CalendarItem = styled.li`
	padding: 5px 0px;
`;
export const Container = styled.div`
	display: flex;
	justify-content: center;
	padding-top: 30px;
	margin-top: 30px;
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
	padding: 15px;
	background-color: #f8f9fa;
	border-radius: 8px;
	margin-bottom: 20px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	justify-content: center;
`;

export const FilterInput = styled.input`
	padding: 8px 12px;
	border: 2px solid #6c757d;
	border-radius: 4px;
	font-size: 14px;
	width: 200px;
	transition: border-color 0.2s, box-shadow 0.2s;

	&:focus {
		outline: 2px solid #000000;
		outline-offset: 1px;
		border-color: #000000;
	}

	&::placeholder {
		color: #6c757d;
	}
`;
export const FilterSelect = styled.select`
	padding: 8px 12px;
	border: 2px solid #6c757d;
	border-radius: 4px;
	font-size: 14px;
	width: 200px;
	transition: border-color 0.2s, box-shadow 0.2s;

	&:focus {
		outline: 2px solid #000000;
		outline-offset: 1px;
		border-color: #000000;
	}

	&::placeholder {
		color: #6c757d;
	}
`;

export const FormWrapper = styled.div`
	width: 100%;
	max-width: 500px;
	margin: 0 auto;
	padding: 20px;
	background-color: #ffffff;
	border-radius: 8px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	display: flex;
	flex-direction: column;
	align-items: stretch;
`;

export const FormInputContainer = styled.div`
	width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
	margin-top: ${({ mt }) => (mt ? '1.5rem' : '0')};
	display: flex;
	flex-direction: column;
	align-items: ${({ fullWidth }) => (fullWidth ? 'stretch' : 'flex-start')};
`;

export const FormLabel = styled.label`
	display: block;
	margin-bottom: 8px;
	font-weight: 600;
	color: #333;
	font-size: 14px;
	text-transform: uppercase;
`;

export const FormInputStyled = styled.input`
	width: 100%;
	padding: 10px 12px;
	border: 2px solid #6c757d;
	border-radius: 4px;
	font-size: 16px;
	transition: border-color 0.2s, outline 0.2s;

	&:focus {
		outline: 2px solid #000000;
		outline-offset: 1px;
		border-color: #000000;
	}
`;

export const FormSelect = styled.select`
	width: 100%;
	padding: 10px 12px;
	border: 2px solid #6c757d;
	border-radius: 4px;
	font-size: 16px;
	background-color: white;
	cursor: pointer;

	&:focus {
		outline: 2px solid #000000;
		outline-offset: 1px;
		border-color: #000000;
	}
`;

export const SubmitButton = styled.button`
	width: 100%;
	padding: 12px;
	background-color: #198754;
	color: white;
	border: none;
	border-radius: 4px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: background-color 0.2s, transform 0.1s;

	&:hover {
		background-color: #157347;
	}

	&:active {
		transform: scale(0.98);
	}
`;
